// extracted by mini-css-extract-plugin
export var blue = "TeamItem-module--blue--606a7";
export var ceTeamItem = "TeamItem-module--ce-team-item--c9240";
export var ceTeamItemContent = "TeamItem-module--ce-team-item-content--e3b81";
export var ceTeamItemIcon = "TeamItem-module--ce-team-item-icon--27685";
export var ceTeamItemImg = "TeamItem-module--ce-team-item-img--910a5";
export var green = "TeamItem-module--green--9d02b";
export var magenta = "TeamItem-module--magenta--3ee2e";
export var orange = "TeamItem-module--orange--84d70";
export var purple = "TeamItem-module--purple--cf3fa";